//TODO: DELETE THIS FILE AFTER EXPERIMENT IS MERGED

import createReactClass from 'create-react-class';
import _ from 'lodash';
import React from 'react';
import PropTypes from 'prop-types';
import * as Symbols from '@wix/santa-editor-symbols';
import { DropDown, DropDownOption, Button } from '@wix/wix-base-ui';

import * as core from '#packages/core';
import * as util from '#packages/util';
import { translate } from '#packages/i18n';
import * as stateManagement from '#packages/stateManagement';
import * as coreBi from '#packages/coreBi';
import constants from '#packages/constants';
import * as BaseUI from '#packages/baseUI';
import { cx } from '#packages/util';
import type { TpaInnerRouteData } from '#packages/stateManagement';
import type { SitemapEntry } from 'types/documentServices';
import type { FullDynamicPagesComboBoxProps } from './dynamicPagesComboBox';
import { INFRA } from './dynamicPagesComboBox';

const isNewWorkspace = util.workspace.isNewWorkspaceEnabled();

const EXCLUDED_CLASSNAMES_FROM_DRAG = [
  'button-content',
  'tooltip-on-ellipsis-content',
  'combo-box-wrapper',
  'c1',
  'selected-content',
  'symbol-close',
  'close-area',
  'selected-container',
  'symbol-arrow-down',
];

const PAGINATION_RANGE = 100;

function getRangeStartForRouteIndex(newIndex: AnyFixMe) {
  let newRangeStart = 0;
  while (newRangeStart + PAGINATION_RANGE <= newIndex) {
    newRangeStart += PAGINATION_RANGE;
  }
  return newRangeStart;
}

type InnerRoute = SitemapEntry | TpaInnerRouteData;

const oldDynamicPageComboBoxPure =
  // eslint-disable-next-line react/prefer-es6-class
  createReactClass<FullDynamicPagesComboBoxProps>({
    displayName: 'dynamicPagesComboBox',
    render() {
      return this.shouldShowInnerRoutesDropDown()
        ? (() => {
            const innerRoutes = this.getInnerRoutesToRender();

            return (
              <div
                key="dynamicPageComboBox"
                className={cx('dynamic-pages-combo-box', 'no-manage-button')}
                style={
                  this.state.isCustomPosition
                    ? _.omit(this.props.style, ['top', 'left'])
                    : this.props.style
                }
                onMouseDown={(e) => {
                  const { classList } = e.target as HTMLDivElement;
                  if (
                    !EXCLUDED_CLASSNAMES_FROM_DRAG.some(
                      (className) =>
                        classList.contains(className) || classList.length === 0,
                    )
                  ) {
                    this.startDrag(e, this.getDragLimits());
                  }
                }}
                onMouseUp={() => {
                  this.endDrag();
                }}
              >
                <div className="dragable-area">
                  {isNewWorkspace ? (
                    <Symbols.symbol name="dragHandler" />
                  ) : (
                    <BaseUI.symbol
                      name="smalldragHandle"
                      className="symbol-smallDragHandle"
                    />
                  )}
                </div>
                <div
                  className={cx('combo-box-wrapper')}
                  onClick={this.handleClickBI}
                >
                  <DropDown
                    value={this.state.selectedRouteValue}
                    shouldTranslate={false}
                    searchBox={true}
                    key="innerRouteDropDown"
                    optionsContainerClassName={cx('dynamic-pages-options', {
                      preview: this.props.previewMode,
                    })}
                    onChange={this.onInnerRouteChange}
                    className="dynamic-pages-combobox"
                  >
                    {this.shouldShowPrevButton() ? (
                      <Button
                        key="prevButton"
                        onClick={this.decreaseRange}
                        className="btn-text"
                      >
                        <span>
                          {translate(
                            'dynamic_pages_routes_navigation_button_back',
                          )}
                        </span>
                      </Button>
                    ) : null}
                    {this.getInnerRoutesDropDownOptions(innerRoutes)}
                    {this.shouldShowNextButton() ? (
                      <Button
                        key="nextButton"
                        onClick={this.increaseRange}
                        className="btn-text"
                      >
                        <span>
                          {translate(
                            'dynamic_pages_routes_navigation_button_next',
                          )}
                        </span>
                      </Button>
                    ) : null}
                  </DropDown>
                </div>
              </div>
            );
          })()
        : null;
    },
    mixins: [core.mixins.editorAPIMixin, util.draggableMixin],
    getInitialState() {
      return {
        shouldShowNavigation: true,
        rangeStartIndex: 0,
      };
    },
    propTypes: {
      previewMode: PropTypes.bool.isRequired,
      editorIsInit: PropTypes.bool.isRequired,
      devModeContext: PropTypes.object.isRequired,
      stageLayout: PropTypes.object,
      innerRoutes: PropTypes.array.isRequired,
      selectedInnerRoute: PropTypes.string,
      routerId: PropTypes.string,
      setSelectedInnerRoute: PropTypes.func.isRequired,
      style: PropTypes.object,
    },
    handleClickBI() {
      this.sendBI(
        coreBi.events.dynamicPageComboBox.click,
        this.getBIParamsNew(this.props.selectedInnerRoute),
      );
    },
    UNSAFE_componentWillReceiveProps(nextProps) {
      if (
        nextProps.editorIsInit &&
        nextProps.selectedInnerRoute &&
        !_.isEmpty(nextProps.innerRoutes) &&
        !this.isCollectionPageOrHasOneRoute()
      ) {
        const index = this.findInnerRouteIndex(
          nextProps.selectedInnerRoute,
          nextProps.innerRoutes,
        );
        this.setState({
          rangeStartIndex: index >= 0 ? getRangeStartForRouteIndex(index) : 0,
          selectedRouteValue: this.getInnerRouteUrl(
            nextProps.innerRoutes[index],
          ),
        });
      }

      if (
        nextProps.routerId !== this.props.routerId ||
        !_.isEqual(this.props.tpaInfo, nextProps.tpaInfo) ||
        !_.isEqual(this.props.innerRoutes, nextProps.innerRoutes)
      ) {
        this.setState({
          shouldShowNavigation: true,
        });
      }
      if (
        nextProps.routerId !== this.props.routerId ||
        !_.isEqual(this.props.innerRoutes, nextProps.innerRoutes)
      ) {
        this.sendBI(
          coreBi.events.dynamicPageComboBox.show,
          this.getBIParamsNew(this.props.selectedInnerRoute),
        );
      }
    },
    shouldComponentUpdate(nextProps, nextState) {
      return (
        !_.isEqual(this.state, nextState) || !_.isEqual(this.props, nextProps)
      );
    },
    isCollectionPageOrHasOneRoute() {
      const { innerRoutes } = this.props;
      if (!innerRoutes) {
        return false;
      }
      return innerRoutes.length === 1;
    },
    shouldShowInnerRoutesDropDown() {
      const editorAPI = this.getEditorAPI();
      const developerContext = editorAPI.dsRead?.pages.getFocusedPageId
        ? editorAPI.developerMode.getContext()
        : {};
      const isPageContext =
        developerContext.type === constants.DEVELOPER_MODE.CONTEXT_TYPES.PAGE;
      const isShowingFixedComponentsEnabled = editorAPI.dsRead?.documentMode
        ? editorAPI.dsRead.documentMode.isShowingFixedComponentsEnabled()
        : true;
      const isThePageFocused = editorAPI.dsRead?.pages.getFocusedPageId
        ? editorAPI.dsRead.pages.getFocusedPageId() ===
          editorAPI.dsRead.pages.getPrimaryPageId()
        : true;
      return (
        isThePageFocused &&
        !this.isCollectionPageOrHasOneRoute() &&
        this.state.shouldShowNavigation &&
        (this.props.routerId || this.props.tpaInfo) &&
        !_.isEmpty(this.props.innerRoutes) &&
        (this.props.previewMode || isPageContext) &&
        isShowingFixedComponentsEnabled
      );
    },
    getInnerRouteUrl(innerRoute: InnerRoute) {
      if (this.props.routerId) {
        return (innerRoute as SitemapEntry).url;
      }
      return (innerRoute as TpaInnerRouteData).path;
    },
    getInnerRoutesDropDownOptions(innerRoutes: InnerRoute[]) {
      return innerRoutes.map((innerRoute) => {
        const innerRouteUrl = this.getInnerRouteUrl(innerRoute);
        const innerRouteName =
          (innerRoute as SitemapEntry).title ??
          (innerRoute as TpaInnerRouteData).name;
        return (
          <DropDownOption
            key={innerRouteUrl}
            value={innerRouteUrl}
            label={innerRouteName}
            shouldTranslate={false}
          />
        );
      });
    },
    sendBI(eventName: AnyFixMe, params: AnyFixMe) {
      const editorAPI = this.getEditorAPI();
      editorAPI.bi.event(eventName, params);
    },
    getInnerRoutesToRender() {
      if (!this.props.innerRoutes) {
        return [];
      }

      return this.props.innerRoutes.slice(
        this.state.rangeStartIndex,
        this.state.rangeStartIndex + PAGINATION_RANGE,
      );
    },
    increaseRange() {
      const newRangeStart = this.state.rangeStartIndex + PAGINATION_RANGE;
      const newSelectedInnerRoute = this.getInnerRouteUrl(
        this.shouldShowPrevButton(newRangeStart)
          ? this.props.innerRoutes[newRangeStart]
          : this.props.innerRoutes[newRangeStart - 1],
      );
      this.sendBI(
        coreBi.events.dynamicPageComboBox.preview_navigate,
        this.getBIParams(newSelectedInnerRoute),
      );
      this.setState({
        rangeStartIndex: newRangeStart,
      });
      this.props.setSelectedInnerRoute(
        newSelectedInnerRoute,
        this.props.routerId,
      );
    },
    decreaseRange() {
      const newRangeStart = this.state.rangeStartIndex - PAGINATION_RANGE;
      const newSelectedInnerRoute = this.getInnerRouteUrl(
        this.props.innerRoutes[newRangeStart],
      );

      this.sendBI(
        coreBi.events.dynamicPageComboBox.preview_navigate,
        this.getBIParams(newSelectedInnerRoute),
      );
      this.setState({
        rangeStartIndex: newRangeStart,
      });
      this.props.setSelectedInnerRoute(
        newSelectedInnerRoute,
        this.props.routerId,
      );
    },
    shouldShowPrevButton(rangeStart: AnyFixMe) {
      rangeStart = rangeStart || this.state.rangeStartIndex;
      const hasLessThenMax = this.props.innerRoutes.length < PAGINATION_RANGE;
      const gotToBottomLimit = rangeStart === 0;

      return !gotToBottomLimit && !hasLessThenMax;
    },
    shouldShowNextButton() {
      const hasLessThenMax = this.props.innerRoutes.length < PAGINATION_RANGE;
      const gotToUpperLimit =
        this.state.rangeStartIndex + PAGINATION_RANGE >=
        this.props.innerRoutes.length;

      return !gotToUpperLimit && !hasLessThenMax;
    },
    goToPreview() {
      const editorAPI = this.getEditorAPI();
      if (!this.props.previewMode) {
        this.sendBI(
          coreBi.events.dynamicPageComboBox.preview_clicked,
          this.getBIParams(this.props.selectedInnerRoute),
        );
        editorAPI.preview.togglePreview(undefined, {
          biParams: { origin: constants.BI.PREVIEW.ORIGIN.DYNAMIC_PAGES },
        });
      }
    },
    getBIParams(innerRouteName: string) {
      const editorAPI = this.getEditorAPI();
      const currentPageId = editorAPI.dsRead.pages.getPrimaryPageId();
      const routerData =
        editorAPI.dsRead.routers.getRouterDataForPageIfExist(currentPageId);
      if (routerData) {
        return {
          item_name: innerRouteName,
          item_path: `${routerData.prefix}/${innerRouteName}`,
          pageId: currentPageId,
          appName: routerData.appDefinitionId,
          isTpa: false,
        };
      }

      const state = editorAPI.store.getState();
      const selectedRoute =
        stateManagement.tpaDynamicPages.selectors.getSelectedRouteInfo(state);
      const currentTpa =
        stateManagement.tpaDynamicPages.selectors.getCurrentRouteInfo(state);
      return {
        item_name: innerRouteName,
        item_path: selectedRoute.path,
        pageId: currentPageId,
        appName: currentTpa.appDefinitionId,
        isTpa: true,
      };
    },
    getBIParamsNew(innerRouteName: string) {
      const editorAPI = this.getEditorAPI();
      const currentPageId = editorAPI.dsRead.pages.getPrimaryPageId();
      const routerData =
        editorAPI.dsRead.routers.getRouterDataForPageIfExist(currentPageId);
      if (routerData) {
        return {
          item_path: innerRouteName,
          item_id: routerData.prefix,
          app_id: routerData.appDefinitionId,
          infra: INFRA.DYNAMIC_PAGES,
        };
      }

      const state = editorAPI.store.getState();
      const selectedRoute =
        stateManagement.tpaDynamicPages.selectors.getSelectedRouteInfo(state);
      const currentTpa =
        stateManagement.tpaDynamicPages.selectors.getCurrentRouteInfo(state);
      return {
        item_path: innerRouteName,
        item_id: selectedRoute.itemTypeIdentifier,
        app_id: currentTpa.appDefinitionId,
        infra: INFRA.TPA_LINKS,
      };
    },
    onInnerRouteChange(newInnerRouteName: string) {
      this.sendBI(
        coreBi.events.dynamicPageComboBox.preview_select_page,
        this.getBIParams(newInnerRouteName),
      );
      this.sendBI(
        coreBi.events.dynamicPageComboBox.item_selected,
        this.getBIParamsNew(this.props.selectedInnerRoute),
      );
      this.props.setSelectedInnerRoute(newInnerRouteName, this.props.routerId);
    },
    close() {
      const editorAPI = this.getEditorAPI();
      const currentPageId = editorAPI.dsRead.pages.getPrimaryPageId();
      const routerData =
        editorAPI.dsRead.routers.getRouterDataForPageIfExist(currentPageId);
      this.sendBI(coreBi.events.dynamicPageComboBox.preview_closed, {
        pageId: currentPageId,
        appName: routerData.appDefinitionId,
      });
      this.setState({
        shouldShowNavigation: false,
      });
    },
    openHelpCenter() {
      const editorAPI = this.getEditorAPI();
      const helpId = 'b853c294-8ff1-418f-b4d2-29d7b59a85c3'; // TODO: change helpid
      const biHelpParams = {
        origin: 'display-combo-box',
        panel_name: 'dynamic-pages-display-combo-box',
        component: this.props.id,
      };

      editorAPI.panelManager.openHelpCenter(helpId, null, biHelpParams);
    },
    findInnerRouteIndex(innerRoute: string, innerRoutes: InnerRoute[]) {
      let index = innerRoutes.findIndex(
        (route) => this.getInnerRouteUrl(route) === innerRoute,
      );
      if (index === -1) {
        const decoded = decodeURIComponent(innerRoute);
        index = innerRoutes.findIndex(
          (route) => this.getInnerRouteUrl(route) === decoded,
        );
      }
      return index === -1 ? 0 : index;
    },
    moveToItem(index: AnyFixMe) {
      const newRoute =
        !_.isEmpty(this.props.innerRoutes) &&
        index < this.props.innerRoutes.length
          ? this.getInnerRouteUrl(this.props.innerRoutes[index])
          : null;
      this.sendBI(
        coreBi.events.dynamicPageComboBox.preview_navigate,
        this.getBIParams(newRoute),
      );
      this.props.setSelectedInnerRoute(newRoute, this.props.routerId);

      this.setState({
        rangeStartIndex: getRangeStartForRouteIndex(index),
      });
    },
    getDragLimits() {
      let { stageLayout } = this.props;

      if (!stageLayout || this.props.isPreview) {
        stageLayout = window.document.body.getBoundingClientRect();
      }

      if (util.fixedStage.isFixedStageEnabled()) {
        return {
          x: [stageLayout.x, stageLayout.right],
          y: [
            stageLayout.top - constants.UI.FIXED_STAGE_MARGIN_TOP,
            stageLayout.bottom,
          ],
        };
      }

      return {
        x: [stageLayout.left, stageLayout.right],
        y: [stageLayout.top, stageLayout.bottom],
      };
    },
    onDragStart() {
      this.props.onDragStart?.();
    },
    onDragEnd() {
      this.props.onDragEnd?.();
    },
  });

export default oldDynamicPageComboBoxPure;
